import { render, staticRenderFns } from "./topic_switch.vue?vue&type=template&id=46f511d5&scoped=true&"
import script from "./topic_switch.vue?vue&type=script&lang=js&"
export * from "./topic_switch.vue?vue&type=script&lang=js&"
import style0 from "./topic_switch.vue?vue&type=style&index=0&id=46f511d5&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f511d5",
  null
  
)

export default component.exports